export default __webpack_public_path__ + "static/goal-welfare-mobile-afcb9d69342e11d2179afcf144e64568.jpg";